import React, { memo, useState, useReducer, useEffect, useMemo, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next'; //번역관련
import { useMst } from '../../../models'; //스토어 로그인 유저 회사번호 불러올 때 사용
import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import CollectedDataList from './ArCollectedDataList';
import Button, { ButtonGroup } from '../../../components/bootstrap/Button';
import SubHeader, { SubHeaderCenter, SubHeaderLeft, SubHeaderRight } from '../../../layout/SubHeader/SubHeader';
import Breadcrumb, { BreadcrumbItem } from '../../../components/bootstrap/Breadcrumb';
import useFilter from '../../../hooks/useFilter';
import { object } from 'prop-types';
import Popovers from '../../../components/bootstrap/Popovers';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import HeaderTop from '../HeaderTop';
import Badge from '../../../components/bootstrap/Badge';
import { AutoSizer, CellMeasurer, CellMeasurerCache, ColumnSizer, MultiGrid } from 'react-virtualized';
import PacketService from '../../../services/PacketService';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { set } from 'lodash';
import Icon from '../../../components/icon/Icon';

let isLoaded = [];
let prevPage = -1

const errorbit = [
	{ label: '전체', value: 'all', color: '#F5BB00' },
	{ label: '정상', value: 'normal', color: '#E9897E' },
	{ label: '배터리부족', value: 'low_battery', color: '#CF6766' },
	{ label: '침수', value: 'flood', color: '#5A5A66' },
	{ label: '누수', value: 'leak', color: '#A2B8AD' },
	{ label: '장기미사용', value: 'long_term_unused', color: '#FFD700' },
	{ label: '동파', value: 'freeze', color: '#CF4500' },
	{ label: '고온', value: 'high_temperature', color: '#A8DDCA' },
	{ label: '검침기 미연결', value: 'meter_connection', color: '#008000' },
	{ label: '검침기 통신', value: 'meter_communication', color: '#0000FF' },
	{ label: 'Data Limit', value: 'data_limit', color: '#800080' },
	{ label: '수질 오염', value: 'water_pollution', color: '#A52A2A' },
	{ label: '유량 과부화', value: 'flow_overload', color: '#D2691E' },
	{ label: '역류', value: 'backflow', color: '#FF00FF' },
	{ label: '옥내 누수', value: 'indoor_leak', color: '#1E90FF' },
	{ label: '배터리 부족', value: 'low_battery', color: '#8B0000' },
];

const ArCollectedData = () => {
	const { t } = useTranslation(['translation', 'menu']);
	const listRef = useRef();
	const { user } = useMst();
	const [refresh, setRefresh] = useState(true);
	const [params, setParams] = useState({});
	const [loading, setLoading] = useState(true);
	const [filterData, setFilterData] = useState([]);
	const [scrollLeft, setScrollLeft] = useState(0);
	const [totalCount, setTotalCount] = useState(0);
	const [filterCount, setFilterCount] = useState(0);

	const cellCache = useMemo(
		() =>
			new CellMeasurerCache({
				fixedWidth: false,
				defaultHeight: 50,
				minWidth: 100,
				fixedHeight: false,
			}),
		[]
	);

	const columns = useMemo(
		() => [
			// { grow: 0, minWidth: 50, maxWidth: 70, name: '번호' },
			{ grow: 1, minWidth: 200, name: '검침 시간', key1: 'Sensing_Time' },
			{ grow: 1, minWidth: 200, name: 'IMEI', key1: 'IMEI' },
			{ grow: 1, minWidth: 30, name: 'SERIAL', key1: 'SerialNumber' },
			{ grow: 1, minWidth: 200, name: '수용가 명', key1: 'customerName' },
			{ grow: 1, minWidth: 200, name: '수용가 번호', key1: 'acceptNumber' },
			{ grow: 1, minWidth: 200, name: '주소', key1: 'customerAddress' },
			{ grow: 1, minWidth: 30, name: '계량기 번호', key1: 'IDENT_NR' },
			{ grow: 1, minWidth: 30, name: '계량기 구경(mm)', key1: 'Diameter' },
			{ grow: 1, minWidth: 30, name: '보고 주기', key1: 'AR_term' },
			{ grow: 1, minWidth: 30, name: '검침 주기', key1: 'SR_term' },
			{ grow: 1, minWidth: 30, name: '검침값(m³)', key1: 'Water_Meter' },
			{ grow: 1, minWidth: 30, name: '검침값 이력(m³)', key1: 'Water_Meter_ALL' },
			{ grow: 1, minWidth: 30, name: '온도', key1: 'Temperature_In' },
			{ grow: 1, minWidth: 30, name: '습도', key1: 'Humidity_In' },
			{ grow: 1, minWidth: 30, name: '통신성공률', key1: 'E_RATE' },
			{ grow: 1, minWidth: 30, name: 'Status', key1: 'Status' },
			{ grow: 1, minWidth: 30, name: '기기 상태', key1: 'Error' },
			{ grow: 1, minWidth: 30, name: '배터리(%)', key1: 'BAT' },
			{ grow: 1, minWidth: 30, name: '탁도(NTU)', key1: 'NTU' },
			{ grow: 1, minWidth: 30, name: 'RSSI', key1: 'RSSI' },
			{ grow: 1, minWidth: 30, name: 'RSRP', key1: 'RSRP' },
			{ grow: 1, minWidth: 30, name: 'RSRQ', key1: 'RSRQ' },
			{ grow: 1, minWidth: 30, name: 'SNR', key1: 'SNR' },
			{ grow: 2, minWidth: 30, name: '펌웨어 버전', key1: 'FW_Version' },
		],
		[]
	);

	console.log(user.me.IMEI)

	const TDCell = useCallback(
		({ columnData, rowData, columnIndex, rowIndex, dataKey }) => {
			let data = null;
			switch (dataKey) {
				case 'IMEI':
					data = columnData ?
						(
							<Badge
								style={{ fontSize: 12 }}
								color='dark'
								onClick={() => {
									user.setIMEI(columnData)
									getData('init');
								}}>
								{columnData}
							</Badge>
						) : 'N/A'
					break
				case 'Water_Meter_ALL':
					data = rowData?.Water_Meter ?
						(
							<Badge
								color='success'
								onClick={() => {
									setDetailData(Array.isArray(columnData) ? columnData : [columnData])
									setArrayModalOpen(true)
								}}>
								{rowData.Water_Meter.map(w => (w == 4294967.295 ? 'fffffff' : w)).join(', ')}
							</Badge>
						) : 'N/A'
					break
				case 'Water_Meter':
					data = columnData ?
						(
							<Badge
								color='primary'
								onClick={() => {
									setDetailData(Array.isArray(columnData) ? columnData : [columnData])
									setArrayModalOpen(true)
								}}>
								{(columnData[0] == 4294967.295 ? 'fffffff' : columnData[0]) || (columnData == 4294967.295 ? 'fffffff' : columnData)}
							</Badge>
						) : 'N/A'
					break
				case 'MIC':
					data = columnData ?
						(
							<Badge
								color='success'
								onClick={() => {
									setDetailData(Array.isArray(columnData) ? columnData : [columnData])
									setArrayModalOpen(true)
								}}>
								{columnData[0] || columnData}
							</Badge>
						) : 'N/A'
					break
				case 'XYZ':
					data = columnData ?
						(
							<Badge
								color='danger'
								onClick={() => {
									setDetailData(Array.isArray(columnData) ? columnData : [columnData])
									setArrayModalOpen(true)
								}}>
								{columnData[0] || columnData}
							</Badge>
						) : 'N/A'
					break
				//Status 값이 0, N/A일 때 정상으로 표시 (sh)
				case 'Status':
					data = columnData ?
						(
							(columnData[0] == 0 ? '정상' : columnData[0]) || (columnData == 0 ? '정상' : columnData)
							
						) : '정상'
					break
				case 'Error':
					// data = columnData ? '0x' + parseInt(columnData, 2).toString(16).padStart(8, '0') : '0'
					// data = columnData ? errorbit.filter((e, i) => columnData && columnData.includes(i - 2)) : 'N/A'
					const indices = [];
					if (columnData) {
						const reversedString = columnData.split('').reverse().join('');

					// 	// 오른쪽에서부터 `1`이 나타나는 인덱스를 찾습니다.
						for (let i = 0; i < reversedString.length; i++) {
							if (reversedString[i] === '1') {
								if (indices.indexOf(errorbit[i + 2].label) === -1)
									indices.push(errorbit[i + 2].label)
							}
						}
					};
					//Error 값 'N/A'가 아닌 '정상'으로 표시(sh)
					data = indices.length > 0 ? indices.join(', ') : '정상';
					
					// data = columnData ? parseInt(columnData, 2).toString(16) : 'N/A'
					break;
				case 'customerName':
					data = <div style={{ textAlign: 'left' }}>{rowData?.install?.customerName || 'N/A'}</div>;
					break;
				case 'customerAddress':
					data = <div style={{ textAlign: 'left' }}>{rowData?.install?.customerAddress || 'N/A'}</div>;
					break;
				case 'acceptNumber':
					data = rowData?.install?.acceptNumber || 'N/A';
					break;
				default:
					data = columnData || 'N/A';
					break;
			}

			return data;
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[filterData]
	);

	const cellRenderer = useCallback(
		({ columnIndex, key, rowIndex, style, parent }) => {
			return (
				<CellMeasurer key={key} cache={cellCache} parent={parent} columnIndex={columnIndex} rowIndex={rowIndex}>
					{rowIndex === 0 ? (
						<div style={style} className={`py-3 text-nowrap text-center ${rowIndex === 0 ? '' : 'border-bottom border-end'}`}>
							{columns[columnIndex]?.name}
						</div>
					) : (
						<div
							style={style}
							className={`p-2 text-nowrap text-center border-bottom border-end cursor-pointer ${rowIndex % 2 === 0 ? 'bg-l50-light' : ''}`}
							onClick={() => {
								// setSelectedUesr(filterData[rowIndex - 1]);
								// setIsUserDetailOpen(true);
							}}>
							{TDCell({
								columnData: filterData[rowIndex - 1][columns[columnIndex]?.key1],
								columnIndex,
								dataKey: columns[columnIndex]?.key1,
								parent,
								rowData: filterData[rowIndex - 1],
								rowIndex,
							})}
						</div>
					)}
				</CellMeasurer>
			);
		},
		[filterData, columns, cellCache, TDCell]
	);

	const onScrollHandler = (e) => {
		console.log(loading, e.scrollTop, e.clientHeight, e.scrollHeight, totalCount, filterData.length, isLoaded)
		if (!loading && e.scrollTop + e.clientHeight >= e.scrollHeight - 300 && totalCount >= filterData.length) {
			if (isLoaded.indexOf(filterData.length) < 0) {
				console.log('getData')
				isLoaded.push(filterData.length);
				getData();
			}
		} else {
			// const keysToCheck = ['id', 'name']; // 체크할 키들
			// const isDuplicate = checkDuplicate(originData, keysToCheck);
			// console.log(isDuplicate); // true
		}

		setScrollLeft(e.scrollLeft)
	};

	const getData = useCallback(async (load) => {
		setLoading(true);
		params.IMEI = user?.me.IMEI || null
		params.type = 'DATA'
		params.page = Math.floor(filterData.length / 30) + 1
		if (load === 'init') {
			setFilterData([])
			isLoaded = [];
			params.page = 1
			prevPage = -1
		}
		console.log(params, filterData, prevPage)	
		if ((!params.dateType || prevPage === params.page) && !params.IMEI ) {
			setLoading(false);
			return
		}
		prevPage = params.page

		const { data } = await PacketService.getPacketList2(params)
		console.log('data.list.length', data.list.length)
		if (load === 'init') {
			setFilterData(data.list.reverse())
		} else {
			setFilterData((prev) => [...prev, ...data.list.reverse()])
		}
		setTotalCount(data.totalCount)
		setFilterCount(data.filterCount)

		setLoading(false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [params, filterData, user.me.IMEI])

	useEffect(() => {
		getData('init');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [params])

	const excelDownload = async () => {
		let tempData = []
		let data = []

		let count = 0;
		do {
			params.type = 'DATA'
			params.page = Math.floor(tempData.length / 30) + 1
			const response = await PacketService.getPacketList2({...params, excel: true})
			data = response.data?.list?.reverse() || []
			if (count === 0) count = response.data?.totalCount || 0

			tempData = tempData.concat(data)
			user.setProgress(Math.floor((tempData.length / count) * 100))
		} while (data.length > 0 && tempData.length < count) 
		
		const wb = XLSX.utils.book_new();

		let temp = []
		let dayFormat = 'YYYY-MM-DD'
		let monthFormat = 'YYYY-MM'
		let yearFormat = 'YYYY'

		let day = {}
		let month = {}
		let year = {}

		tempData.map((x) => {
			let dayKey = moment(x.Sensing_Time).format(dayFormat)
			let monthKey = moment(x.Sensing_Time).format(monthFormat)
			let yearKey = moment(x.Sensing_Time).format(yearFormat)

			if (!day[dayKey + '_' + x.install?.acceptNumber]) {
				day[dayKey + '_' + x.install?.acceptNumber] = {
					'일자': dayKey,
					'수용가명': x.install?.customerName || '',
					'수용가번호': x.install?.acceptNumber || '',
					'계량기번호': x?.IDENT_NR || '',
					'총 사용량': x?.Water_Meter ? x?.Water_Meter[0] : '',
					'통신성공률': x?.E_RATE || '',
					'IMEI': x?.IMEI || '',
					'SerialNumber': x?.SerialNumber || '',
					'주소': (x?.customerAddress || '') + ' ' + (x?.customerAddressDetail || ''),
					'계량기구경': x?.Diameter || '',
					'보고주기': x?.AR_term || '',
					'검침주기': x?.SR_term || '',
					'온도': x?.Temperature_In || '',
					'습도': x?.Humidity_In || '',
					'기기상태': x?.Status || '',
					'배터리': x?.BAT || '',
					'탁도': x?.NTU || '',
				}
			}

			if (!month[monthKey + '_' + x.install?.acceptNumber]) {
				month[monthKey + '_' + x.install?.acceptNumber] = {
					'연도': monthKey.split('-')[0],
					'월': monthKey.split('-')[1],
					'수용가명': x.install?.customerName || '',
					'수용가번호': x.install?.acceptNumber || '',
					'계량기번호': x?.IDENT_NR || '',
					'총 사용량': x?.Water_Meter ? x?.Water_Meter[0] : '',
					'통신성공률': x?.E_RATE || '',
					'IMEI': x?.IMEI || '',
					'SerialNumber': x?.SerialNumber || '',
					'주소': (x?.customerAddress || '') + ' ' + (x?.customerAddressDetail || ''),
					'계량기구경': x?.Diameter || '',
					'보고주기': x?.AR_term || '',
					'검침주기': x?.SR_term || '',
					'온도': x?.Temperature_In || '',
					'습도': x?.Humidity_In || '',
					'기기상태': x?.Status || '',
					'배터리': x?.BAT || '',
					'탁도': x?.NTU || '',
				}
			}

			if (!year[yearKey + '_' + x.install?.acceptNumber]) {
				year[yearKey + '_' + x.install?.acceptNumber] = {
					'연도': yearKey,
					'수용가명': x.install?.customerName || '',
					'수용가번호': x.install?.acceptNumber || '',
					'계량기번호': x?.IDENT_NR || '',
					'총 사용량': x?.Water_Meter ? x?.Water_Meter[0] : '',
					'통신성공률': x?.E_RATE || '',
					'IMEI': x?.IMEI || '',
					'SerialNumber': x?.SerialNumber || '',
					'주소': (x?.customerAddress || '') + ' ' + (x?.customerAddressDetail || ''),
					'계량기구경': x?.Diameter || '',
					'보고주기': x?.AR_term || '',
					'검침주기': x?.SR_term || '',
					'온도': x?.Temperature_In || '',
					'습도': x?.Humidity_In || '',
					'기기상태': x?.Status || '',
					'배터리': x?.BAT || '',
					'탁도': x?.NTU || '',
				}
			}

			day[dayKey + '_' + x.install?.acceptNumber]['총 사용량'] += (x.Water_Meter ? x.Water_Meter[0] || 0 : 0)
			month[monthKey + '_' + x.install?.acceptNumber]['총 사용량'] += (x.Water_Meter ? x.Water_Meter[0] || 0 : 0)
			year[yearKey + '_' + x.install?.acceptNumber]['총 사용량'] += (x.Water_Meter ? x.Water_Meter[0] || 0 : 0)

			temp.push({
				'일자': moment(x.Sensing_Time).format('YYYY-MM-DD HH:mm:ss'),
				'수용가명': x.install?.customerName || '',
				'수용가번호': x.install?.acceptNumber || '',
				'계량기번호': x?.IDENT_NR || '',
				'총 사용량': x?.Water_Meter ? x?.Water_Meter[0] : '',
				'통신성공률': x?.E_RATE || '',
				'IMEI': x?.IMEI || '',
				'SerialNumber': x?.SerialNumber || '',
				'주소': (x?.customerAddress || '') + ' ' + (x?.customerAddressDetail || ''),
				'계량기구경': x?.Diameter || '',
				'보고주기': x?.AR_term || '',
				'검침주기': x?.SR_term || '',
				'온도': x?.Temperature_In || '',
				'습도': x?.Humidity_In || '',
				'기기상태': x?.Status || '',
				'배터리': x?.BAT || '',
				'탁도': x?.NTU || '',
			})
		})

		const ws = XLSX.utils.json_to_sheet(temp);
		XLSX.utils.book_append_sheet(wb, ws, '일자별');

		temp = []
		Object.keys(month).map((key) => {
			temp.push(month[key])
		})

		const ws2 = XLSX.utils.json_to_sheet(temp);
		XLSX.utils.book_append_sheet(wb, ws2, '월별');

		temp = []
		Object.keys(year).map((key) => {
			temp.push(year[key])
		})

		const ws3 = XLSX.utils.json_to_sheet(temp);
		XLSX.utils.book_append_sheet(wb, ws3, '연도별');

		XLSX.writeFile(wb, `데이터수집 ${moment(params.startDate).format('YYYY년 MM월 DD일')}~${moment(params.endDate).format('YYYY년 MM월 DD일')}_${moment().format('YYYY년 MM월 DD일')}.xlsx`);
	}

	return (
		<PageWrapper className='fluid' title={t('수집 데이터')}>
			<SubHeader className={'belt-header'}>
				<SubHeaderLeft>
					{user?.IMEI && (
						<>
							<div style={{ color: '#ffffff', cursor: 'pointer' }} onClick={(e) => {
								console.log('user.IMEI', user.IMEI)
								user.setIMEI(undefined)
								getData('init');
							}}>
								<Icon icon='Arrow-left' fontSize={20} forceFamily='bootstrap'
								// onClick={(e) => {
								// 	user.setIEMI(null)
								// }}
								/>
							</div>
							<div style={{ color: '#ffffff' }}>
								{user.IMEI}
							</div>
						</>
					)}
					{!user?.IMEI && (
					<Breadcrumb list={null} tag={'nav'}>
						<BreadcrumbItem tag='nav' to={'/arcollectedData'}>
							{t('수집 데이터')}
						</BreadcrumbItem>
					</Breadcrumb>)}
				</SubHeaderLeft>
			</SubHeader>
			<Page container='fluid' style={{ paddingTop: '0.7rem' }} >
				{!user?.IMEI && (
				<Card stretch className={`custom-box-shadow rounded-2 p-0`} >
					<CardBody className={`rounded-2 align-items-center text-center p-3 py-1`} >
						<HeaderTop setParams={setParams} disableMap={true} totalText={`전체 데이터: ${filterCount}/${totalCount}`}
							startDate={moment().subtract(1, 'month').add(1, 'day').format('YYYY-MM-DD')}
							endDate={moment().format('YYYY-MM-DD')}
						disableExcelUp excelDownload={excelDownload} />
					</CardBody>
				</Card>)}
				<div className='row'>
					<Card className={`custom-box-shadow rounded-2`} style={{ height: user?.IMEI ? 'calc(90vh)' : 'calc(90vh - 120px)' }}>
						<CardBody className={`rounded-2 align-items-center text-center`} style={{ padding: 0 }} >
							{filterData?.length > 0 && (
								<AutoSizer
									onResize={() => {
										listRef.current.recomputeGridSize();
									}}>
									{({ width, height }) => {
										// console.log(width, height);
										return (
											<ColumnSizer columnCount={columns.length} columnMaxWidth={300} width={width}>
												{({ adjustedWidth, getColumnWidth, registerChild }) => (
													<div className=''>
														<MultiGrid
															ref={listRef}
															// deferredMeasurementCache={cellCache}
															cellRenderer={cellRenderer}
															classNameTopLeftGrid='border-light border-end border-bottom fw-bold'
															classNameTopRightGrid='border-light border-bottom fw-bold'
															classNameBottomLeftGrid='border-light border-end'
															// classNameBottomRightGrid="border border-0 border-light border-end-1"
															fixedColumnCount={3}
															fixedRowCount={1}
															height={height}
															width={width}
															overscanRowCount={5}
															overscanColumnCount={5}
															// columnCount={Object.keys(data[0]).length}
															columnCount={columns.length}
															columnWidth={cellCache.columnWidth}
															rowCount={filterData.length + 1}
															rowHeight={cellCache.rowHeight}
															// isScrolling={isScrolling}
															onScroll={onScrollHandler}
															scrollLeft={scrollLeft}
														/>
													</div>
												)}
											</ColumnSizer>
										);
									}}
								</AutoSizer>
							)}

						</CardBody>
					</Card>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default memo(ArCollectedData);
